<template>
  <section class="blogSlider">
    <ul class="cursorIcons">
      <li><v-icon @click="prev"> mdi-chevron-left </v-icon></li>
      <li><v-icon @click="next"> mdi-chevron-right </v-icon></li>
    </ul>
    <div class="slidingSection">
      <slick ref="slick" :options="slickOptions">
        <div class="px-1" v-for="(img, index) in images" :key="'as' + index">
          <img src="https://media.istockphoto.com/photos/red-generic-sedan-car-isolated-on-white-background-3d-illustration-picture-id1189903200?k=20&m=1189903200&s=612x612&w=0&h=L2bus_XVwK5_yXI08X6RaprdFKF1U9YjpN_pVYPgS0o=" alt="">
        </div>
      </slick>
    </div>
  </section>
</template>

<script>
import Slick from "vue-slick";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";
export default {
  name: "ContentSlider",
  components: { Slick },
  props: ["images"],
  data: () => ({
    slickOptions: {
      slidesToShow: 4,
      dots: false,
      arrows: false,
      fade: false,
    },
    media: [],
    index: 0,
    visible: false,
  }),
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },
  },
};
</script>

<style lang="scss" scoped>
.blogSlider {
  position: relative;
}

img{
  width: 100%;
}

.cursorIcons {
  display: flex;
  list-style: none;
  padding-left: 0;
  position: absolute;
  top: -65px;
  right: 3px;
  li {
    margin-left: 10px;
    .v-icon {
      padding: 10px;
      background: #f4f4f4;
    }
  }
}
</style>
